/* eslint-disable arrow-body-style */
/* eslint-disable padding-line-between-statements */
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import _, { update } from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { TranslatorContext, useTranslator } from '@jutro/locale';

import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import metadata from './PolicySummary.metadata.json5';
import PolicyDetailsAccordion from '../PolicyDetailsAccordion/PolicyDetailsAccordion';
import PropertyDetailsAccordion from '../PropertyDetailsAccordion/PropertyDetailsAccordion';
import ConstructionDetailsAccordion from '../ConstructionDetailsAccordion/ConstructionDetailsAccordion';
import RoofsAndAdditionAccordion from '../RoofsAndAdditionAccordion/RoofsAndAdditionAccordion';
import CoveragesAccordion from '../CoveragesAccordion/CoveragesAccordion.jsx';
import messages from './PolicySummary.messages.js'
import styles from './PolicySummary.module.scss'

const PolicySummary = props => {
    const {
        policyDetailsData,
        lobData_TWIA,
        policyTransactionDetails,
        producerOfServiceValue,
        producerOfRecordValue,
        policyTransactionData,
        initialSubmission,
        renewalData,
        isRenewalSummary
    } = props;

    const translator = useTranslator();
    const isDwelling = _.get(lobData_TWIA, 'homeOwners.dwellingDTO.policyType') === 'Dwelling and Personal Property';
    const isTenant = _.get(lobData_TWIA, 'homeOwners.dwellingDTO.policyType') === 'Tenant Personal Property Only';
    const isMH = _.get(lobData_TWIA, 'homeOwners.dwellingDTO.policyType') === 'Manufactured Home';
    const isApartmentOrCondo = _.get(lobData_TWIA, 'homeOwners.dwellingDTO.policyType') === 'Condo Unit Owner'
        || (_.get(lobData_TWIA, 'homeOwners.dwellingDTO.policyType')) === 'Tenant Personal Property Only'
        && (_.get(lobData_TWIA, 'homeOwners.dwellingDTO.homeDetails.structureType_TWIA') === 'AptBuilding');



    const createRoofAndRepairs_TWIA = useCallback(() => {
        const MH = isMH ? '-MH' : '';

        const items = [];
        const roofUpdate = _.get(lobData_TWIA, 'homeOwners.dwellingDTO.constructionDetails.roofUpdateDtls_TWIA');
        const roofAdditionns = _.get(lobData_TWIA, 'homeOwners.dwellingDTO.constructionDetails.repairAdditionsDTO_TWIA');
        // DE17694
        if (!_.isUndefined(roofUpdate)) {
            _.get(lobData_TWIA, 'homeOwners.dwellingDTO.constructionDetails.roofUpdateDtls_TWIA').forEach((entry) => {
                const date = new Date(entry.roofUpdateDate?.year, entry.roofUpdateDate?.month, entry.roofUpdateDate?.day);
                const formattedDate = `${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getDate().toString().padStart(2, '0')}/${date.getFullYear().toString().slice(-2)}`;
                items.push({
                    // DE11212 - Manufactured Home type label
                    'type': isMH ? translator(messages.addedLivingSpace) : translator(messages.roofUpdate),
                    'date': formattedDate,
                    'cert': entry.hasWPI8CertOfCompIssued_TWIA ? 'Yes' : 'No',
                    'desc': entry.roofUpdateType,
                });
            });
        }

        if (!_.isUndefined(roofAdditionns)) {
            _.get(lobData_TWIA, 'homeOwners.dwellingDTO.constructionDetails.repairAdditionsDTO_TWIA').forEach((entry) => {
                const date = new Date(entry.repairDate?.year, entry.repairDate?.month, entry.repairDate?.day);
                const formattedDate = `${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getDate().toString().padStart(2, '0')}/${date.getFullYear().toString().slice(-2)}`;
                items.push({
                    // DE11212 - Manufactured Home type label
                    'type': isMH ? translator(messages.addedLivingSpaceRepairsAddition) : translator(messages.repairsAdditions),
                    'date':formattedDate,
                    'cert': entry.hasWPI8CertOfCompIssued_TWIA ? 'Yes' : 'No',
                    'desc': entry.repairDesc
                });
            });
        }


        return items.sort((a, b) => {
            return a.date - b.date;
        });
    }, [isMH, lobData_TWIA, translator])

    const roofAndRepairs = createRoofAndRepairs_TWIA();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        policyDetailsSection: {
            policyDetailsData,
            lobData_TWIA,
            policyTransactionDetails,
            producerOfServiceValue,
            producerOfRecordValue,
            isDwelling,
            isTenant,
            isMH,
            isApartmentOrCondo
        },
        policyDetailsAccordion: {
            visible: !isRenewalSummary
        },
        propertyDetailsSection: {
            policyDetailsData,
            lobData_TWIA,
            policyTransactionDetails,
            producerOfServiceValue,
            producerOfRecordValue,
            isDwelling,
            isTenant,
            isMH,
            isApartmentOrCondo
        },
        propertyDetailsAccordion: {
            visible: !isRenewalSummary
        },
        constructionDetailsSection: {
            policyDetailsData,
            lobData_TWIA,
            policyTransactionDetails,
            producerOfServiceValue,
            producerOfRecordValue,
            isDwelling,
            isTenant,
            isMH,
            isApartmentOrCondo
        },
        constructionDetailsAccordion: {
            visible: !isRenewalSummary
        },
        roofRepairsDetailsSection: {
            roofAndRepairs,
            lobData_TWIA
        },
        roofRepairsDetailsAccordion: {
            visible: !isRenewalSummary
        },
        coveragesDetailsSection: {
            visible: !_.isUndefined(lobData_TWIA) && !_.isEmpty(lobData_TWIA),
            policyDetailsData,
            lobData_TWIA,
            policyTransactionDetails,
            policyTransactionData,
            renewalData
        },
        coveragessDetailsAccordion: {
            title: isRenewalSummary ? translator(messages.coverages) : translator(messages.coverageDetails),
            className: isRenewalSummary ? 'accordionTitle bottomBorder': 'noborder'
        }
    };



    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {

        },
        resolveComponentMap: {
            policyDetailsComponent: PolicyDetailsAccordion,
            propertyDetailsComponent: PropertyDetailsAccordion,
            constructionDetailsComponent: ConstructionDetailsAccordion,
            roofRepairsDetailsComponent: RoofsAndAdditionAccordion,
            coveragesDetailsComponent: CoveragesAccordion
        }
    };




    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            //model={submissionVM}
            // onModelChange={updateWizardData}
            // onValueChange={writeValue}
            // showErrors={showErrors}
            // onValidationChange={setComponentValidation}
            // callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
        />
    );
};

PolicySummary.propTypes = wizardProps;
PolicySummary.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func,
    }).isRequired,
    authHeader: PropTypes.shape({}).isRequired,
};
export default withAuthenticationContext(withRouter(PolicySummary));
